import * as React from "react";
import { styled } from "@mui/system";
import MUITabs, { TabsProps } from "@mui/material/Tabs";

// export interface Test extends Omit<TabsProps, "variant"> {
//   variant?: TabsProps["variant"] | "secondary";
// }

export const Tabs = styled((props: TabsProps) => <MUITabs {...props} />, {
  name: "Tabs",
  slot: "Root",
  overridesResolver: (props, styles) => [],
})(({ theme }) => ({
  "&.MuiTabs-root": {
    alignItems: "center",
    borderBottom: "1px solid " + theme.palette.primary.borderDefault,
    transition: "none",
  },
  "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-indicator": {
    height: 0,
  },
  "&.MuiTabs-root .MuiTabs-scrollButtons.Mui-disabled": {
    opacity: 0.3,
  },
  "&.MuiTabs-root .MuiTabs-scrollButtons > .MuiSvgIcon-root": {
    fontSize: 20,
  },

  //vertical tabs
  "&.MuiTabs-root.MuiTabs-vertical": {
    borderBottom: 0,
    position: "fixed",
    right: "40%",
    top: "31%",
    boxShadow: theme.shadows[1],
  },
  "&.MuiTabs-root.MuiTabs-vertical .MuiTabs-fixed .MuiTabs-indicator": {
    display: "none",
  },
  "&.MuiTabs-root .MuiTabs-fixed .MuiTabs-flexContainerVertical": {
    height: "100%",
    maxWidth: 40,
    width: 40,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 4,
    paddingRight: 4,
  },
  "&.MuiTabs-root .MuiTabs-fixed .MuiTabs-flexContainerVertical .MuiTab-root": {
    width: 40,
    minWidth: 40,
    minHeight: 40,
    marginBottom: 8,
    ":last-child": {
      marginBottom: 0,
    },
    padding: 0,
    "& svg": {
      color: theme.palette.primary.borderActive,
    },
  },
  "&.MuiTabs-root .MuiTabs-fixed .MuiTabs-flexContainerVertical .MuiButtonBase-root.MuiTab-root.Mui-selected":
    {
      background: theme.palette.primary.background + " !important",
      borderRadius: 2,
      borderBottom: "none !important",
    },
}));
